export default __webpack_public_path__ + "static/media/Jason-Koon.c305b2ec.png";